<template>
  <div>
    <FormSwap
      :dialog="switch_dialog"
      :closeDialog="closeSwitchDialog"
      :selected_event="selected_event"
      @update="getEvents"
    />
    <v-dialog v-model="received_swaps_dialog" max-width="800">
      <ReceivedSwapList :closeDialog="closeReceivedSwaps" />
    </v-dialog>
    <v-card class="flex-grow-1">
      <v-app-bar dark dense color="red lighten-1" class="">
        <v-container
          fluid
          class="pa-0 ma-0 d-flex flex-row justify-space-between align-content-center"
        >
          <span class="text-md-h5 text-sm-h5 my-auto">Escala</span>

          <v-btn icon @click="received_swaps_dialog = true">
            <span class="notification">{{ getReceivedSwapsLength }}</span>
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </v-container>
      </v-app-bar>
      <v-card-text>
        <v-container fluid>
          <v-calendar
            ref="employee_calendar"
            type="month"
            :events="events"
            :event-color="getEventColor"
            @click:event="substitution"
          >
          </v-calendar>
        </v-container>
        <v-container fluid>
          <v-subheader> Legenda </v-subheader>
          <v-row>
            <v-col>
              <v-list :items="scale_types">
                <v-row>
                  <template v-for="type in scale_types">
                    <v-col :key="type.id" cols="12" md="6" lg="6" sm="12" class="ma-0 pa-0">
                      <v-avatar>
                        <v-icon :color="type.color"> mdi-square </v-icon>
                      </v-avatar>
                      {{ type.initials }} - {{ type.name }}
                    </v-col>
                  </template>
                </v-row>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FormSwap from './FormSwap'
import ReceivedSwapList from './ReceivedSwapList'
export default {
  name: 'Scale',
  components: { FormSwap, ReceivedSwapList },
  data: function () {
    return {
      events: [],
      switch_dialog: false,
      selected_event: {},
      received_swaps_dialog: false,
    }
  },
  computed: {
    ...mapGetters('utils', ['getScaleTypeById']),
    ...mapState('utils', ['scale_types']),
    ...mapState('employees', ['employee_scales']),
    ...mapState('scales', ['swaps_received']),
    getReceivedSwapsLength() {
      return this.swaps_received.length
    },
  },
  mounted: function () {
    this.getEvents()
  },
  methods: {
    substitution(event) {
      this.selected_event = event.event
      console.log(event)
      this.showSwitchDialog()
    },
    getEvents() {
      const events = []
      this.employee_scales.map((scale) => {
        scale.dates.map((date) => {
          const scale_type = this.getScaleTypeById(date.scale_type_id)
          events.push({
            name: `${scale_type.initials} ${
              date.is_swap
                ? `${
                    date.type == 'REQUESTER'
                      ? ' - Troca - ' + date.employee_recipient
                      : ' - Substituindo - ' + date.creator
                  }`
                : ''
            }`,
            start: date.date,
            end: date.date,
            color: scale_type.color,
            timed: false,
            scale_date: date,
          })
        })
      })
      this.events = events
    },
    getEventColor(event) {
      return event.color
    },
    showSwitchDialog() {
      this.switch_dialog = true
    },
    closeSwitchDialog() {
      this.switch_dialog = false
      this.selected_event = {}
      this.getEvents()
    },
    closeReceivedSwaps() {
      this.received_swaps_dialog = false
    },
  },
}
</script>

<style>
.notification {
  position: absolute;
  background-color: white;
  border-radius: 10px;
  top: -5px;
  left: 5px;
  padding: 0 4px;
  color: black;
  font-size: 12px;
  border: solid 0.2px red;
  z-index: 20;
  /* padding: 4px; */
}
</style>
